import React, { useState, useEffect,useMemo } from 'react';
import SendGiftModal from './SendGiftModal.js';
import VideoFavouritesModal from './VideoFavouritesModal';
import './AllUser.css'
import useAuth from '../../../useAuth'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { MEDIA_SERVER_URL } from '../../../constants/constants.js';

const VideoModal = ({ showVideoModal, handleCloseVideoModal, videoData, setVideoData, handleViewVideo }) => {
    const allUserVideoApis = require("../../../apis/all_user_video");
    videoData = videoData || [];
    // console.log(videoData, 'videoDatavideoDatavideoData')
    const { user } = useAuth()
    const role = user ? user.role : null;

    const hassubfeturelike = user?.permissions?.Users?.['View Video']?.subfeatures?.Like || user?.role === 'superadmin';
    const hassubfeturecomment = user?.permissions?.Users?.['View Video']?.subfeatures?.Comment || user?.role === 'superadmin';
    const hassubfetureAddViews = user?.permissions?.Users?.['View Video']?.subfeatures?.['Add Views'] || user?.role === 'superadmin';
    const hassubfetureAddShare = user?.permissions?.Users?.['View Video']?.subfeatures?.['Add Share'] || user?.role === 'superadmin';
    const hassubfetureSendGift = user?.permissions?.Users?.['View Video']?.subfeatures?.['Send Gift'] || user?.role === 'superadmin';

    const hassubfetureDeletecomment = user?.permissions?.Users?.['View Video']?.subfeatures?.['Delete Comment'] || user?.role === 'superadmin';
    const hassubfetureDeleteLike = user?.permissions?.Users?.['View Video']?.subfeatures?.['Delete Like'] || user?.role === 'superadmin';
    const hassubfetureDeleteView = user?.permissions?.Users?.['View Video']?.subfeatures?.['Delete View'] || user?.role === 'superadmin';
    const hassubfetureDeleteShare = user?.permissions?.Users?.['View Video']?.subfeatures?.['Delete Share'] || user?.role === 'superadmin';

    const [isEditingLikes, setIsEditingLikes] = useState(false);
    const [editedLikes, setEditedLikes] = useState(false);
    const [filteredData, setFilteredData] = useState(videoData); // Store filtered data

    // const [isEditingDiamonds, setIsEditingDiamonds] = useState(false);
    // const [editedDiamonds, setEditedDiamonds] = useState(0);

    const [isEditingShared, setIsEditingShared] = useState(false);
    const [editedShared, setEditedShared] = useState(0);



    const [isEditingViewCount, setIsEditingViewCount] = useState(false);
    const [editedViewCount, setEditedViewCount] = useState(0);

    const [isDeletingVideoCount, setIsDeletingVideoCount] = useState(false);
    const [deletedVideoCount, setDeletedVideoCount] = useState(0);


    const [showSendGiftModal, setShowSendGiftModal] = useState(false);

    const openSendGiftModal = () => {
        setShowSendGiftModal(true);
    };

    const closeSendGiftModal = () => {
        setShowSendGiftModal(false);
    };



    const [isLoading, setIsLoading] = useState(false);
    const [favoritesTarget, setFavoritesTarget] = useState(null);
    const [favoritesMessage, setFavoritesMessage] = useState('');
    useEffect(() => {
        if (!showVideoModal) { setFavoritesTarget(null); setFavoritesMessage(''); }
    }, [showVideoModal]);

    // const handleEditDiamonds = (index, diamonds) => {
    //     setIsEditingDiamonds(index);
    //     setEditedDiamonds(diamonds);
    // };

    const handleEditLikes = (index, likes) => {
        setIsEditingLikes(index);
        setEditedLikes(likes);
    };
    const [ShowAddlikeModal, setShowAddlikeModal] = useState(false);
    const [CurrentlikeVideoIndex, setCurrentlikeVideoIndex] = useState(null);
    const [currentdeletelikeVideoIndex, setcurrentdeletelikeVideoIndex] = useState(null);
    const [showdeletelikeModal, setshowdeletelikeModal] = useState(false);
    const [CurrentcommentVideoIndex, setCurrentcommentVideoIndex] = useState(null)
    const [ShowAddcommentModal, setShowAddcommentModal] = useState(false)
    const [CurrentdeletecommentVideoIndex, setCurrentdeletecommentVideoIndex] = useState(null)
    const [ShowdeletecommentModal, setShowdeletecommentModal] = useState(false)
    const openAddlikeModal = (index) => {
        setCurrentlikeVideoIndex(index);
        setShowAddlikeModal(true);
    }
    const opendeletelikeModal = (videoid) => {
        setcurrentdeletelikeVideoIndex(videoid)
        setshowdeletelikeModal(true)
    }

    //comment

    const openAddcommentModal = (index) => {
        setCurrentcommentVideoIndex(index);
        setShowAddcommentModal(true);
    }

    const opendeletecommentModel = (videoid) => {
        setCurrentdeletecommentVideoIndex(videoid);
        setShowdeletecommentModal(true);

    }

    const handleaddcomment = async (addcomment) => {
        if (addcomment !== null) {
            try {
                setIsLoading(true);
                const updatedVideoData = [...videoData];
                // updatedVideoData[index].shared = editedShared;

                // Simulating an API call to update the shared count (replace this with the actual API call)
                await allUserVideoApis.updateVideocomment(CurrentcommentVideoIndex, addcomment);
                handleViewVideo(videoData[0].user_id)

                setVideoData(updatedVideoData);
                setIsLoading(false);
                alert(`Add ${addcomment} succsefully Comment `);

                setShowAddcommentModal(false)

            } catch (error) {
                setIsLoading(false);
                console.error('Error updating shared count:', error);
            }
        }
    };

    const handldeletecomment = async (deletecomment) => {
        if (deletecomment !== null) {
            try {
                setIsLoading(true);
                const updatedVideoData = [...videoData];
                // updatedVideoData[index].shared = editedShared;

                // Simulating an API call to update the shared count (replace this with the actual API call)
                await allUserVideoApis.deleteVideocomment(CurrentdeletecommentVideoIndex, deletecomment);
                handleViewVideo(videoData[0].user_id)

                setVideoData(updatedVideoData);
                setIsLoading(false);
                alert(`Deleted ${deletecomment}  Comment succsefully`);

                setShowdeletecommentModal(false)
            } catch (error) {
                setIsLoading(false);
                console.error('Error updating shared count:', error);
            }
        }
    }

    //end comment

    const handleSaveLikes = async (addlike) => {
        if (addlike !== null) {
            try {
                setIsLoading(true);
                const updatedVideoData = [...videoData];

                // Simulating an API call to update the likes count (replace this with actual API call)
                const response = await allUserVideoApis.updateLikeVideos(CurrentlikeVideoIndex, addlike);
                if (response.success) {
                    alert(`Add ${addlike} Like succsefully  & updated  `);
                    handleViewVideo(videoData[0].user_id)

                    setVideoData(updatedVideoData);
                    setShowAddlikeModal(false)
                    setIsLoading(false);

                }
                else {
                    alert(response.message);

                }
            } catch (error) {
                setIsLoading(false);
                console.error('Error updating like count:', error);
            }
        }
    };

    const handleDeletelikeVideoCount = async (deleteCount) => {
        try {
            setIsLoading(true);


            if (deleteCount === null) {
                alert(`please add Delete like greater than 0 `);

                return;
            }

            const parsedCount = parseInt(deleteCount);
            if (isNaN(parsedCount) || parsedCount <= 0) {
                throw new Error('Please enter a valid number greater than zero');
            }


            // Call the API to delete the specified count of videos
            await allUserVideoApis.deleteVideolikeCount(currentdeletelikeVideoIndex, parsedCount);
            handleViewVideo(videoData[0].user_id)

            // Update the count of videos that have been deleted
            setDeletedVideoCount(prevCount => prevCount + parsedCount);
            alert(`Like Succefully remove `);
            setshowdeletelikeModal(false)
            setIsLoading(false);


        } catch (error) {
        }
    };


    // const handleSaveDiamonds = async (index) => {
    //     if (editedDiamonds !== null && editedDiamonds !== videoData[index].diamond_value) {
    //         try {
    //             setIsLoading(true);
    //             const updatedVideoData = [...videoData];
    //             updatedVideoData[index].diamond_value = editedDiamonds;

    //             // Simulating an API call to update the diamonds count (replace this with the actual API call)
    //             await allUserVideoApis.updateDiamondVideos(videoData[index].id, editedDiamonds);

    //             setEditedDiamonds(0);
    //             setIsEditingDiamonds(false);
    //             setVideoData(updatedVideoData);
    //             setIsLoading(false);
    //         } catch (error) {
    //             setIsLoading(false);
    //             console.error('Error updating diamond count:', error);
    //         }
    //     }
    // };

    const handleEditShared = (index, shared) => {
        setIsEditingShared(index);
        setEditedShared(shared);
    };
    const [showAddshareModal, setShowAddshareModal] = useState(false);
    const [currentshareVideoIndex, setCurrentshareVideoIndex] = useState(null);
    const [showdeleteshareModal, setshowdeleteshareModal] = useState(false);
    const [currentdeleteshareVideoIndex, setcurrentdeleteshareVideoIndex] = useState(null);

    const openAddshareModal = (index) => {
        setCurrentshareVideoIndex(index);
        setShowAddshareModal(true);
    }

    const opendeletesharemodel = (videoid) => {
        setcurrentdeleteshareVideoIndex(videoid)
        setshowdeleteshareModal(true)

    }
    // Handler for saving edited shared count
    const handleSaveShared = async (addshare) => {
        if (addshare !== null) {
            try {
                setIsLoading(true);
                const updatedVideoData = [...videoData];
                // updatedVideoData[index].shared = editedShared;

                // Simulating an API call to update the shared count (replace this with the actual API call)
                await allUserVideoApis.updateVideoShared(currentshareVideoIndex, addshare);
                handleViewVideo(videoData[0].user_id)

                setEditedShared(0);
                setIsEditingShared(false);
                setVideoData(updatedVideoData);
                setIsLoading(false);
                alert(`Add succsefully shared}`);

                setShowAddshareModal(false)
            } catch (error) {
                setIsLoading(false);
                console.error('Error updating shared count:', error);
            }
        }
    };

    const handleDeleteshareVideoCount = async (deleteCount) => {
        try {
            setIsLoading(true);


            if (deleteCount === null) {
                alert(`please add share greater than 0 `);

                return;
            }

            const parsedCount = parseInt(deleteCount);
            if (isNaN(parsedCount) || parsedCount <= 0) {
                throw new Error('Please enter a valid number greater than zero');
            }


            // Call the API to delete the specified count of videos
            await allUserVideoApis.deleteVideoshareCount(currentdeleteshareVideoIndex, parsedCount);
            handleViewVideo(videoData[0].user_id)

            // Update the count of videos that have been deleted
            setDeletedVideoCount(prevCount => prevCount + parsedCount);
            alert(`Shared Succefully remove `);
            setshowdeleteshareModal(false)
            setIsLoading(false);


        } catch (error) {
        }
    };

    // // Handler for editing view count
    // const handleEditViewCount = (index, views) => {
    //     setIsEditingViewCount(index);
    //     setEditedViewCount(views);
    // };

    // // Handler for saving edited view count
    // const handleSaveViewCount = async (index) => {
    //     if (editedViewCount !== null && editedViewCount !== videoData[index].viewCount) {
    //         try {
    //             setIsLoading(true);
    //             const updatedVideoData = [...videoData];
    //             updatedVideoData[index].viewCount = editedViewCount;

    //             // Simulating an API call to update the view count (replace this with the actual API call)
    //             await allUserVideoApis.updateVideoCount(videoData[index].id, editedViewCount);

    //             setEditedViewCount(0);
    //             setIsEditingViewCount(false);
    //             setVideoData(updatedVideoData);
    //             setIsLoading(false);
    //         } catch (error) {
    //             setIsLoading(false);
    //             console.error('Error updating view count:', error);
    //         }
    //     }
    // };
    const [showAddViewsModal, setShowAddViewsModal] = useState(false);
    const [currentVideoId, setCurrentVideoId] = useState(null);
    const [showdeleteViewsModal, setshowdeleteViewsModal] = useState(false);
    const [deletedvideoid, setdeletedvideoid] = useState(null)
    const openAddViewsModal = (videoId) => {
        setCurrentVideoId(videoId);
        setShowAddViewsModal(true);
    };
    const opendeletemodel = (videoid) => {
        setdeletedvideoid(videoid)
        setshowdeleteViewsModal(true)

    }
    const closeAddViewsModal = () => {
        setShowAddViewsModal(false);
        setshowdeleteViewsModal(false)
        setShowAddshareModal(false)
        setshowdeleteshareModal(false)
        setShowAddlikeModal(false)
        setshowdeletelikeModal(false)
        setShowAddcommentModal(false)
        setShowdeletecommentModal(false)
    };

    const handleAddViews = async (additionalViews) => {
        if (currentVideoId !== null && additionalViews > 0) {
            try {
                setIsLoading(true);

                // Find the video in the videoData array by ID
                const videoIndex = videoData.findIndex(video => video.id === currentVideoId);
                if (videoIndex === -1) {
                    throw new Error('Video not found');
                }

                const updatedVideoData = [...videoData];
                updatedVideoData[videoIndex].viewCount += parseInt(additionalViews, 10);

                // Simulate API call to update the view count (replace with actual API call)
                await allUserVideoApis.updateVideoCount(currentVideoId, additionalViews);
                handleViewVideo(videoData[0].user_id)

                setVideoData(updatedVideoData);
                alert(`Total views are now ${updatedVideoData[videoIndex].viewCount}`);
                setShowAddViewsModal(false);
                setIsLoading(false);


            } catch (error) {
                console.error('Error updating view count:', error);
            }
        }
    };

    const handleDeleteVideoCount = async (deleteCount) => {
        try {
            setIsDeletingVideoCount(true);
            setIsLoading(true);

            // const count = prompt('Enter the number of videos to delete:');

            if (deleteCount === null) {
                setIsDeletingVideoCount(false);
                console.log('Deletion cancelled by the user');
                return;
            }

            const parsedCount = parseInt(deleteCount);
            if (isNaN(parsedCount) || parsedCount <= 0) {
                throw new Error('Please enter a valid number greater than zero');
            }

            // Update the count of videos that are going to be deleted
            setDeletedVideoCount(parsedCount);

            // Call the API to delete the specified count of videos
            await allUserVideoApis.deleteVideoViewCount(deletedvideoid, parsedCount);
            handleViewVideo(videoData[0].user_id)

            // Update the count of videos that have been deleted
            setDeletedVideoCount(prevCount => prevCount + parsedCount);
            alert(`Views Succefully remove `);
            setshowdeleteViewsModal(false)
            setIsLoading(false);


            // Perform any actions after successful deletion
        } catch (error) {
            setIsDeletingVideoCount(false);
            console.error('Error deleting video count:', error);
            // Handle errors and show appropriate error messages
        }
    };





    const handleBlockVideo = async (index) => {
        // Ask for confirmation before blocking the video
        const confirmed = window.confirm("Are you sure you want to block this video?");

        if (confirmed) {
            try {
                const updatedVideoData = [...videoData];
                updatedVideoData[index].block = true; // Set the 'block' field to true

                // Simulating an API call to block the video (replace this with your actual API call)
                await allUserVideoApis.blockVideo(videoData[index].id);

                setVideoData(updatedVideoData);
            } catch (error) {
                console.error('Error blocking video:', error);
                // Implement error handling logic as needed
            }
        } else {
            // If the user cancels the action, you can perform any other action here or simply return
            console.log('Block action canceled by the user.');
            return;
        }
    };




    const modalStyle = {
        display: showVideoModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        margin: '10% auto',
        padding: '10px',
        border: '1px solid #888',
        width: '100%',
        top: 0,


    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold'
    };

    const tableStyle = {
        width: '95%',
        borderCollapse: 'collapse'
    };

    const thStyle = {
        border: '1px solid #ddd',
        padding: '8px',
        textAlign: 'center'
    };

    const tdStyle = {
        border: '1px solid #ddd',
        padding: '8px',
        textAlign: 'center'
    };

    const videoStyle = {
        width: '100px', // Set the desired width for the video
        height: '100px', // Set the desired height for the video
    };
    const loaderStyle = {
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #3498db',
        borderRadius: '50%',
        width: '15px',
        height: '15px',
        animation: 'spin 1s linear infinite',
        marginLeft: '5px',
        display: isLoading ? 'block' : 'none',
    };
    const buttonStyle = {
        padding: '8px 12px',
        margin: '10 8px', // Added margin to create space between buttons
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        marginRight: '6px'
    };

    const deleteButtonStyle = {
        padding: '8px 12px',
        margin: '10 8px', // Added margin to create space between buttons
        background: 'red',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
    };


    // Function to show the video when a user clicks on the thumbnail
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [thumbnailClicked, setThumbnailClicked] = useState(false);

    const showVideo = (video) => {
        setSelectedVideo(video);
        setThumbnailClicked(true);
    };
    const closethumbModal = () => {
        setThumbnailClicked(false);
        setSelectedVideo(null);
    };
    const handleNoAccess = () => {
        alert('You are not able to access this feature.');
    };
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage] = useState(5);
    const [pageRange, setPageRange] = useState([1, 2, 3, 4]);
    let totalPages = Math.ceil(filteredData?.length / postPerPage);

    const handleDateChange = (date, type) => {
        if (type === 'start') {
            setStartDate(date);
        } else {
            setEndDate(date);
        }
    };

    const handleClean = () => {
        setStartDate(null);
        setEndDate(null);
    };
    // const filterfeedDataByDate = () => {
    //     if (!startDate || !endDate) return videoData; // If no dates are selected, show all data
    //     return videoData.filter((video) => {
    //         const videoDate = new Date(video.created);
    //         return videoDate >= startDate && videoDate <= endDate;
    //     });
    // };
    
    
    // const filterfeedDataByDateAndSearch = () => {
    //     let filteredData = filterfeedDataByDate();
    //     if (searchQuery) {
    //       filteredData = filteredData.filter((video) =>
    //         (video?.title && video?.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
    //         (video?.description && video?.description.toLowerCase().includes(searchQuery.toLowerCase()))
    
    //       );
    //     }
    
    //     return filteredData;
    //   };
    //   useEffect(() => {
    //     setFilteredData(filterfeedDataByDateAndSearch());
    //   }, [startDate, endDate, searchQuery, videoData]);

    const filterfeedDataByDate = () => {
        if (!startDate || !endDate) return videoData; // If no dates are selected, show all data
        return videoData.filter((video) => {
            const videoDate = new Date(video.created);
            return videoDate >= startDate && videoDate <= endDate;
        });
    };
    
      // Filter function by date and search query
      const filterfeedDataByDateAndSearch = () => {
        let filteredData = filterfeedDataByDate();
        if (searchQuery) {
          filteredData = filteredData.filter((video) =>
            (video?.title && video?.title.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (video?.description && video?.description.toLowerCase().includes(searchQuery.toLowerCase()))
          );
        }
        return filteredData;
      };
    
      // Memoize videoData to prevent unnecessary re-renders
      const stableVideoData = useMemo(() => videoData, [videoData]);
    
      // Update filtered data when dependencies change
      useEffect(() => {
        const newFilteredData = filterfeedDataByDateAndSearch();
        setFilteredData((prev) => {
          // Only update state if data has genuinely changed
          if (JSON.stringify(prev) !== JSON.stringify(newFilteredData)) {
            return newFilteredData;
          }
          return prev;
        });
      }, [startDate, endDate, searchQuery, stableVideoData]); // Depend on stableVideoData
    
    
    // useEffect(() => {
    //     setFilteredData(filterfeedDataByDateAndSearch()); // Filter chat data whenever start or end date changes
    // }, [startDate, endDate, videoData]);
    const currentvideo = filteredData.slice(
        (currentPage - 1) * postPerPage,
        currentPage * postPerPage
    );
    useEffect(() => {
        const initialRange = [];
        const rangeSize = 4;
        const totalVisiblePages = Math.min(rangeSize, totalPages);

        for (let i = 1; i <= totalVisiblePages; i++) {
            initialRange.push(i);
        }
        setPageRange(initialRange);
    }, [totalPages]);

    const updatePageRange = (startPage) => {
        const rangeSize = 4;
        const newRange = [];

        for (let i = startPage; i < startPage + rangeSize && i <= totalPages; i++) {
            newRange.push(i);
        }

        setPageRange(newRange);
    };

    const handlePageClick = (page) => {
        setCurrentPage(page);
        if (page === pageRange[pageRange.length - 1] && page < totalPages) {
            updatePageRange(page);
        }
        if (page === pageRange[0] && page > 1) {
            updatePageRange(page - 3);
        }
    };

    const handleFirst = () => {
        setCurrentPage(1);
        updatePageRange(1);
    };

    const handleLast = () => {
        setCurrentPage(totalPages);
        const lastRangeStart = Math.max(1, Math.floor((totalPages - 1) / 4) * 4 + 1);
        updatePageRange(lastRangeStart);
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            if (currentPage === pageRange[0]) {
                const previousRangeStart = Math.max(pageRange[0] - 4, 1);
                updatePageRange(previousRangeStart);
            } else {
                setCurrentPage(currentPage - 1);
            }
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            if (currentPage === pageRange[pageRange.length - 1]) {
                updatePageRange(pageRange[pageRange.length - 1]);
            } else {
                setCurrentPage(currentPage + 1);
            }
        }
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={handleCloseVideoModal}>&times;</span>
                <h2>User Videos</h2>
                <input
                    type="text"
                    placeholder="Search by Title or Discription..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                    style={{
                        padding: '10px',
                        marginBottom: '10px',
                        width: '100%',
                        fontSize: '16px',
                        borderRadius: '5px',
                        border: '1px solid #ddd',
                    }}
                />
                <div >
                    <DatePicker
                        selected={startDate}
                        onChange={(date) => handleDateChange(date, 'start')}
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="Start Date"
                        maxDate={new Date()} // Ensure start date is not in the future
                        dateFormat="dd:MM:yyyy"
                        style={{
                            padding: '5px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                        }}
                    />
                    <span style={{ margin: '0 10px' }}>to</span>
                    <DatePicker
                        selected={endDate}
                        onChange={(date) => handleDateChange(date, 'end')}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        placeholderText="End Date"
                        minDate={startDate} // Ensure end date is not before start date
                        maxDate={new Date()} // Disable selecting future dates
                        dateFormat="dd:MM:yyyy"
                        style={{
                            padding: '5px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            fontSize: '14px',
                        }}
                    />

                    <button
                        // style={styles.buttonStyles}
                        onClick={handleClean}
                    >
                        Clean
                    </button>
                </div>

                <table style={tableStyle}>
                    <thead>
                        <tr>
                            <th style={thStyle}>ID</th>
                            <th style={thStyle}>Date</th>

                            <th style={thStyle}>Video</th>
                            <th style={thStyle}>Comment</th>
                            <th style={thStyle}>Views</th>
                            <th style={thStyle}>Shared</th>
                            <th style={thStyle}>Diamonds</th>
                            <th style={thStyle}>likes</th>
                            <th style={thStyle}>Favorites</th>
                            {/* <th style={thStyle}>Action</th> */}
                            <th style={thStyle}>Gift_section</th>
                            {/* <th style={thStyle}>Date</th> */}




                        </tr>
                    </thead>
                    <tbody>
                        {currentvideo.map((video, index) => (
                            <tr key={index}>
                                <td style={tdStyle}>{video.id}</td>
                                <td style={tdStyle}>
                                    {new Date(video.created).toLocaleString()}
                                </td>
                                <td style={tdStyle}>

                                    <img
                                        src={`${MEDIA_SERVER_URL}/${video.thum}`}
                                        onClick={() => showVideo(video.video)}

                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            borderRadius: "20%",
                                        }}

                                    />
                                </td>
                                <td style={tdStyle}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p style={{ marginRight: '12px' }}>
                                            {video.comments.length}
                                        </p>
                                        <button onClick={() => {
                                            if (hassubfeturecomment) {
                                                openAddcommentModal(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...buttonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfeturecomment
                                                        ? '#C5C6C7'
                                                        : 'blue', // Set red background when there is access
                                                cursor: !hassubfeturecomment ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >

                                            Add Comment</button>
                                        <button onClick={() => {
                                            if (hassubfetureDeletecomment) {
                                                opendeletecommentModel(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...deleteButtonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureDeletecomment
                                                        ? '#C5C6C7'
                                                        : 'red', // Set red background when there is access
                                                cursor: !hassubfetureDeletecomment ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Delete</button>

                                    </div>
                                </td>
                                <td style={tdStyle}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p style={{ marginRight: '12px' }}>{video.viewCount}</p>
                                        <button onClick={() => {
                                            if (hassubfetureAddViews) {
                                                openAddViewsModal(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...buttonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureAddViews
                                                        ? '#C5C6C7'
                                                        : 'blue', // Set red background when there is access
                                                cursor: !hassubfetureAddViews ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >
                                            Add</button>

                                        <button onClick={() => {
                                            if (hassubfetureDeleteView) {
                                                opendeletemodel(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...deleteButtonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureDeleteView
                                                        ? '#C5C6C7'
                                                        : 'red', // Set red background when there is access
                                                cursor: !hassubfetureDeleteView ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Delete</button>

                                    </div>
                                </td>

                                <td style={tdStyle}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p style={{ marginRight: '12px' }}>{video.shareCount}</p>
                                        <button onClick={() => {
                                            if (hassubfetureAddShare) {
                                                openAddshareModal(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...buttonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureAddShare
                                                        ? '#C5C6C7'
                                                        : 'blue', // Set red background when there is access
                                                cursor: !hassubfetureAddShare ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Add share</button>

                                        <button onClick={() => {
                                            if (hassubfetureDeleteShare) {
                                                opendeletesharemodel(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...deleteButtonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureDeleteShare
                                                        ? '#C5C6C7'
                                                        : 'red', // Set red background when there is access
                                                cursor: !hassubfetureDeleteShare ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Delete</button>

                                    </div>
                                </td>

                                <td style={tdStyle}>
                                    {video.diamond_value}
                                </td>

                                <td style={tdStyle}>

                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <p style={{ marginRight: '12px' }}>{video.likeCount}</p>
                                        <button onClick={() => {
                                            if (hassubfeturelike) {
                                                openAddlikeModal(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...buttonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfeturelike
                                                        ? '#C5C6C7'
                                                        : 'blue', // Set red background when there is access
                                                cursor: !hassubfeturelike ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Add Like</button>
                                        <button onClick={() => {
                                            if (hassubfetureDeleteLike) {
                                                opendeletelikeModal(video.id)
                                            } else {
                                                handleNoAccess()
                                            }
                                        }}
                                            style={{
                                                ...deleteButtonStyle, // Spread the existing styles
                                                backgroundColor:
                                                    !hassubfetureDeleteLike
                                                        ? '#C5C6C7'
                                                        : 'red', // Set red background when there is access
                                                cursor: !hassubfetureDeleteLike ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                            }}
                                        >Delete</button>

                                    </div>

                                </td>

                                <td style={tdStyle}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span>{video.favourite || 0}</span>
                                        <button style={{ ...buttonStyle, backgroundColor: !hassubfeturelike ? '#C5C6C7' : 'blue' }}
                                            onClick={() => {
                                                if (!hassubfeturelike) { handleNoAccess(); return; }
                                                setFavoritesMessage(''); setFavoritesTarget({ video, remove: false });
                                            }}>Add Favorites</button>
                                        <button style={{ ...deleteButtonStyle, backgroundColor: !hassubfetureDeleteLike ? '#C5C6C7' : 'red' }}
                                            onClick={() => {
                                                if (!hassubfetureDeleteLike) { handleNoAccess(); return; }
                                                setFavoritesMessage(''); setFavoritesTarget({ video, remove: true });
                                            }}>Delete</button>
                                    </div>
                                </td>

                                <td style={tdStyle}>
                                    <button onClick={() => {
                                        if (hassubfetureSendGift) {
                                            openSendGiftModal()
                                        } else {
                                            handleNoAccess()
                                        }
                                    }}
                                        style={{
                                            ...buttonStyle, // Spread the existing styles
                                            backgroundColor:
                                                !hassubfetureSendGift
                                                    ? '#C5C6C7'
                                                    : 'blue', // Set red background when there is access
                                            cursor: !hassubfetureSendGift ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                                        }}
                                    >Send Gift</button>
                                </td>


                                {/* Send Gift Modal */}



                            </tr>
                        ))}
                    </tbody>
                </table>
                {/* **************pagination********************* */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <button onClick={handleFirst} disabled={currentPage === 1}>
                        First
                    </button>
                    <button onClick={handlePrevious} disabled={currentPage === 1}>
                        Previous
                    </button>
                    {pageRange.map((page) => (
                        <button
                            key={page}
                            onClick={() => handlePageClick(page)}
                            style={{
                                padding: '5px 10px',
                                backgroundColor: currentPage === page ? '#007bff' : '#f8f9fa',
                                color: currentPage === page ? 'white' : 'black',
                                border: '1px solid #ddd',
                                cursor: 'pointer',
                            }}
                        >
                            {page}
                        </button>
                    ))}
                    <button onClick={handleNext} disabled={currentPage === totalPages}>
                        Next
                    </button>
                    <button onClick={handleLast} disabled={currentPage === totalPages}>
                        Last
                    </button>
                </div>



                {/* **************pagination********************* */}

                {favoritesMessage && <p role="status" style={{ color: '#287a3e' }}>{favoritesMessage}</p>}
                {favoritesTarget && <VideoFavouritesModal
                    key={`${favoritesTarget.video.id}-${favoritesTarget.remove}`}
                    video={favoritesTarget.video} remove={favoritesTarget.remove}
                    onClose={() => setFavoritesTarget(null)}
                    onSaved={(videoId, total, message) => {
                        setVideoData((previous) => previous.map((video) => video.id === videoId ? { ...video, favourite: total } : video));
                        setFavoritesMessage(message); setFavoritesTarget(null);
                    }}
                />}
                <SendGiftModal showSendGiftModal={showSendGiftModal} closeSendGiftModal={closeSendGiftModal} />

            </div>

            <AddViewsModal
                showAddViewsModal={showAddViewsModal}
                closeAddViewsModal={closeAddViewsModal}
                handleAddViews={handleAddViews}
                loading={isLoading}

            />
            <DeleteViewsModal
                showdeleteViewsModal={showdeleteViewsModal}
                closeAddViewsModal={closeAddViewsModal}
                handledeleteViews={handleDeleteVideoCount}
                loading={isLoading}

            />
            <Addshare
                showAddshareModal={showAddshareModal}
                closeAddViewsModal={closeAddViewsModal}
                handleEditShared={handleSaveShared}
                loading={isLoading}

            />
            <DeleteshareModal
                showdeleteshareModal={showdeleteshareModal}
                closeAddViewsModal={closeAddViewsModal}
                handledeleteShared={handleDeleteshareVideoCount}
                loading={isLoading}

            />
            <Addlike
                showaddlikeModal={ShowAddlikeModal}
                closeAddlikeModal={closeAddViewsModal}
                handleaddlike={handleSaveLikes}
                loading={isLoading}


            />
            <Deletelike
                showdeletelikeModal={showdeletelikeModal}
                closedeletelikeModal={closeAddViewsModal}
                handledeletelike={handleDeletelikeVideoCount}
                loading={isLoading}


            />
            <Addcomment

                showaddcommentModal={ShowAddcommentModal}
                closeaddcommmentModal={closeAddViewsModal}
                handleaddcomment={handleaddcomment}
                loading={isLoading}

            />
            <Deletecomment
                showdeletecommentModal={ShowdeletecommentModal}
                closedeletecommmentModal={closeAddViewsModal}
                handledeletecomment={handldeletecomment}
                loading={isLoading}
            />
            <Thumbnail
                showModal={thumbnailClicked}
                closeModal={closethumbModal}
                selectedVideo={selectedVideo}
            // loading={isLoading}

            />
        </div>
    );
};

export default VideoModal;



const AddViewsModal = ({ showAddViewsModal, closeAddViewsModal, handleAddViews, loading }) => {
    const [viewCount, setViewCount] = useState(0);

    const handleSubmit = () => {
        handleAddViews(viewCount);
    };

    const modalStyle = {
        display: showAddViewsModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeAddViewsModal}>&times;</span>
                <h2>Add Views</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={viewCount}
                    onChange={(e) => setViewCount(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


//deleting views

const DeleteViewsModal = ({ showdeleteViewsModal, closeAddViewsModal, handledeleteViews, loading }) => {
    const [deleteCount, setdeleteCount] = useState(0);

    const handleSubmit = () => {
        handledeleteViews(deleteCount);
    };

    const modalStyle = {
        display: showdeleteViewsModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeAddViewsModal}>&times;</span>
                <h2>Delete Views</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={deleteCount}
                    onChange={(e) => setdeleteCount(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


//add share

const Addshare = ({ showAddshareModal, closeAddViewsModal, handleEditShared, loading }) => {
    const [addshare, setaddshare] = useState(0);

    const handleSubmit = () => {
        handleEditShared(addshare);
    };

    const modalStyle = {
        display: showAddshareModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeAddViewsModal}>&times;</span>
                <h2>Add Share</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={addshare}
                    onChange={(e) => setaddshare(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


//delete share model
const DeleteshareModal = ({ showdeleteshareModal, closeAddViewsModal, handledeleteShared, loading }) => {
    const [deleteCount, setdeleteCount] = useState(0);

    const handleSubmit = () => {
        handledeleteShared(deleteCount);
    };

    const modalStyle = {
        display: showdeleteshareModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeAddViewsModal}>&times;</span>
                <h2>Delete Share</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={deleteCount}
                    onChange={(e) => setdeleteCount(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


//add like

const Addlike = ({ showaddlikeModal, closeAddlikeModal, handleaddlike, loading }) => {
    const [addlike, setaddlike] = useState(0);

    const handleSubmit = () => {
        handleaddlike(addlike);
        setaddlike(0)
    };

    const modalStyle = {
        display: showaddlikeModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeAddlikeModal}>&times;</span>
                <h2>Add Like</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={addlike}
                    onChange={(e) => setaddlike(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


//delete like

const Deletelike = ({ showdeletelikeModal, closedeletelikeModal, handledeletelike, loading }) => {
    const [deletelike, setdeletelike] = useState(0);

    const handleSubmit = () => {
        handledeletelike(deletelike);
        setdeletelike(0)
    };

    const modalStyle = {
        display: showdeletelikeModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closedeletelikeModal}>&times;</span>
                <h2>Delete Like</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={deletelike}
                    onChange={(e) => setdeletelike(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};

//add comment
const Addcomment = ({ showaddcommentModal, closeaddcommmentModal, handleaddcomment, loading }) => {
    const [addcomment, setaddcomment] = useState(0);

    const handleSubmit = () => {
        handleaddcomment(addcomment);
        setaddcomment(0)
    };

    const modalStyle = {
        display: showaddcommentModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closeaddcommmentModal}>&times;</span>
                <h2>Add Comment</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={addcomment}
                    onChange={(e) => setaddcomment(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};

//delete comment

const Deletecomment = ({ showdeletecommentModal, closedeletecommmentModal, handledeletecomment, loading }) => {
    const [deletecomment, setdeletecomment] = useState(0);

    const handleSubmit = () => {
        handledeletecomment(deletecomment);
        setdeletecomment(0)
    };

    const modalStyle = {
        display: showdeletecommentModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '400px',
        height: '400px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.8)',
        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        backgroundColor: '#fefefe',
        width: '100%',
        height: '100%',
        borderRadius: '10px',
        padding: '20px',
        boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#aaa',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };

    const inputStyle = {
        width: '80%',
        padding: '10px',
        margin: '10px auto',
        borderRadius: '5px',
        border: '1px solid #ccc',
        boxSizing: 'border-box'
    };

    const buttonStyle = {
        padding: '8px 12px',
        margin: '10px 8px',
        background: 'blue',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
    };

    return (
        <div className="modal" style={modalStyle}>
            <div className="modal-content" style={modalContentStyle}>
                <span className="close" style={closeButtonStyle} onClick={closedeletecommmentModal}>&times;</span>
                <h2>Delete Comment</h2>
                {loading && (
                    <div className="loader-container">
                        <div className="loader"> </div>
                    </div>
                )}
                <input
                    type="number"
                    value={deletecomment}
                    onChange={(e) => setdeletecomment(e.target.value)}
                    style={inputStyle}
                />
                <button style={buttonStyle} onClick={handleSubmit}>Submit</button>
            </div>
        </div>
    );
};


const Thumbnail = ({ showModal, closeModal, selectedVideo }) => {

    // console.log(selectedVideo, 'selectedVideo')
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `${MEDIA_SERVER_URL}/${selectedVideo}`;
        link.download = selectedVideo; // Optional: Set the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const modalStyle = {
        display: showModal ? 'block' : 'none',
        position: 'fixed',
        zIndex: 1,
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: '550px',
        height: '500px',
        overflow: 'auto',
        backgroundColor: 'rgba(0,0,0,0.6)',

        borderRadius: '10px',
        padding: '20px'
    };

    const modalContentStyle = {
        // backgroundColor: '#fefefe',
        // width: '100%',
        // height: '100%',
        // borderRadius: '10px',
        // padding: '20px',
        // boxSizing: 'border-box',
        textAlign: 'center'
    };

    const closeButtonStyle = {
        color: '#fefefe',
        float: 'right',
        fontSize: '28px',
        fontWeight: 'bold',
        cursor: 'pointer'
    };
    const downloadButtonStyle = {
        position: 'fixed',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: 'red',
        color: '#fff',
        padding: '10px 20px',
        borderRadius: '5px',
        border: 'none',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        textAlign: 'center',
    };

    return (
        <div className="modal" style={modalStyle}>
            {/* <div className="modal-content" style={modalContentStyle}> */}
           
            <span className="close" style={closeButtonStyle} onClick={closeModal}>&times;</span>
            {selectedVideo && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>

                    <video controls width="220" >
                        <source
                            src={`${MEDIA_SERVER_URL}/${selectedVideo}`}
                            type="video/mp4"
                        />
                    </video>
                   
                </div>
                
            )}
            {/* </div> */}
            <button
                        onClick={handleDownload}
                        style={downloadButtonStyle}
                    >
                        Download Video
                    </button>
        </div>
    );


}
